var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _vm.onResize,
          expression: "onResize",
        },
      ],
      staticClass: "pa-0 ma-0",
      attrs: { fluid: "" },
    },
    [
      _c(
        "v-card",
        { staticClass: "mb-2", attrs: { flat: "" } },
        [
          _c(
            "v-card-text",
            { staticClass: "pa-2" },
            [
              _c("v-breadcrumbs", {
                staticClass: "pa-0",
                attrs: { items: _vm.breadcrumbs },
                scopedSlots: _vm._u([
                  {
                    key: "item",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-breadcrumbs-item",
                          {
                            staticClass: "text-subtitle-2",
                            style: item.disabled
                              ? "cursor:default"
                              : "cursor:pointer",
                            attrs: { disabled: item.disabled },
                            on: {
                              click: function ($event) {
                                return _vm.handleNavigation(
                                  item.path[item.path.length - 1]
                                )
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(item.text) + " ")]
                        ),
                      ]
                    },
                  },
                  {
                    key: "divider",
                    fn: function () {
                      return [_c("v-icon", [_vm._v("mdi-chevron-right")])]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "mb-2", attrs: { flat: "" } },
        [
          _c(
            "v-toolbar",
            {
              staticStyle: { cursor: "default" },
              attrs: { flat: "", color: "toolbar", height: "60" },
            },
            [
              _c(
                "span",
                [
                  _c("v-toolbar-title", [
                    _vm._v(_vm._s(_vm.currentFolderName)),
                  ]),
                ],
                1
              ),
              _c("v-divider", {
                staticClass: "mx-4",
                attrs: { inset: "", vertical: "" },
              }),
              _c(
                "v-col",
                { staticClass: "pl-0", attrs: { cols: "3" } },
                [
                  _c("PartySelect", {
                    attrs: {
                      selectedParties: _vm.selectedParties,
                      includeOwnerRetailerAdGroups: true,
                    },
                    on: {
                      "update:selectedParties": function ($event) {
                        _vm.selectedParties = $event
                      },
                      "update:selected-parties": function ($event) {
                        _vm.selectedParties = $event
                      },
                      remove: _vm.removeParty,
                    },
                  }),
                ],
                1
              ),
              _vm.files.length > 0
                ? _c(
                    "v-col",
                    { attrs: { cols: "2" } },
                    [
                      _c("v-select", {
                        staticStyle: { "margin-top": "26px" },
                        attrs: {
                          dense: "",
                          outlined: "",
                          label: "Order By",
                          "background-color": "input",
                          items: _vm.orderOptions,
                          "menu-props": { offsetY: true },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "append",
                              fn: function () {
                                return [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on: tooltip }) {
                                              return [
                                                _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    {
                                                      staticClass: "pa-0",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.handleIconClick.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        },
                                                        mousedown: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                        },
                                                      },
                                                    },
                                                    tooltip
                                                  ),
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.sortAscending
                                                            ? "mdi-sort-descending"
                                                            : "mdi-sort-ascending"
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3610148560
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Sort " +
                                            _vm._s(
                                              _vm.sortAscending
                                                ? "Descending"
                                                : "Ascending"
                                            )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          292520156
                        ),
                        model: {
                          value: _vm.selectedOrderOption,
                          callback: function ($$v) {
                            _vm.selectedOrderOption = $$v
                          },
                          expression: "selectedOrderOption",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-col",
                { staticClass: "ml-auto", attrs: { cols: "auto" } },
                [
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "offset-y": "",
                        "nudge-bottom": 5,
                        "close-on-content-click": false,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  {
                                    staticClass: "ml-auto text-capitalize",
                                    attrs: {
                                      rounded: "",
                                      text: "",
                                      color: "grey darken-2",
                                    },
                                  },
                                  on
                                ),
                                [
                                  _c("v-icon", { attrs: { left: "" } }, [
                                    _vm._v("mdi-filter-outline"),
                                  ]),
                                  _vm._v(" Filter "),
                                  _c("v-badge", {
                                    staticClass: "ml-1 mb-2",
                                    attrs: {
                                      color: "accent",
                                      content: _vm.filterCount,
                                      value: _vm.filterCount > 0,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.filterMenu,
                        callback: function ($$v) {
                          _vm.filterMenu = $$v
                        },
                        expression: "filterMenu",
                      },
                    },
                    [
                      _c(
                        "v-card",
                        { attrs: { width: "350" } },
                        [
                          _c("v-card-text", [
                            _c(
                              "div",
                              { staticClass: "mt-2" },
                              [
                                _c("DocumentTags", {
                                  attrs: { vertical: true },
                                  on: {
                                    cancelLoad: () => (_vm.loading = false),
                                  },
                                  model: {
                                    value: _vm.tags,
                                    callback: function ($$v) {
                                      _vm.tags = $$v
                                    },
                                    expression: "tags",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "d-flex align-center", attrs: { cols: "3" } },
                [
                  _c("v-text-field", {
                    staticClass: "flex-grow-1 rounded-r-0",
                    attrs: {
                      label: "Search",
                      placeholder: "Search files and folders",
                      "hide-details": "auto",
                      "background-color": "input",
                      dense: "",
                      outlined: "",
                      clearable: "",
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.loadFiles(true)
                      },
                    },
                    model: {
                      value: _vm.filterText,
                      callback: function ($$v) {
                        _vm.filterText = $$v
                      },
                      expression: "filterText",
                    },
                  }),
                  _c(
                    "v-btn",
                    {
                      staticClass: "rounded-l-0",
                      attrs: { color: "primary", depressed: "", height: "40" },
                      on: {
                        click: function ($event) {
                          return _vm.loadFiles(true)
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-magnify")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "auto" } },
                [
                  _c(
                    "v-btn-toggle",
                    {
                      attrs: { mandatory: "", dense: "" },
                      model: {
                        value: _vm.viewMode,
                        callback: function ($$v) {
                          _vm.viewMode = $$v
                        },
                        expression: "viewMode",
                      },
                    },
                    [
                      _c(
                        "v-btn",
                        { attrs: { value: "grid", small: "" } },
                        [_c("v-icon", [_vm._v("mdi-view-grid")])],
                        1
                      ),
                      _c(
                        "v-btn",
                        { attrs: { value: "list", small: "" } },
                        [_c("v-icon", [_vm._v("mdi-view-list")])],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        {
          staticClass: "file-drop-zone",
          class: { "drag-over": _vm.dragOver },
          staticStyle: { "min-height": "400px" },
          attrs: { flat: "" },
          on: {
            drop: _vm.onDrop,
            dragover: function ($event) {
              $event.preventDefault()
              _vm.dragOver = true
            },
            dragleave: function ($event) {
              $event.preventDefault()
              _vm.dragOver = false
            },
            dragenter: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "v-card-text",
            { staticClass: "pa-2" },
            [
              _vm.loading
                ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
                : [
                    _vm.viewMode === "grid"
                      ? _c(
                          "div",
                          { staticClass: "file-grid" },
                          [
                            _c(
                              "v-row",
                              { staticClass: "pb-16" },
                              [
                                _vm._l(_vm.filteredFolders, function (folder) {
                                  return _c(
                                    "v-col",
                                    {
                                      key: folder.id,
                                      staticClass: "pa-2",
                                      attrs: { cols: "auto" },
                                    },
                                    [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            top: "",
                                            "nudge-bottom": "20px",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on }) {
                                                  return [
                                                    _c(
                                                      "v-card",
                                                      _vm._g(
                                                        {
                                                          staticClass:
                                                            "folder-card",
                                                          attrs: { hover: "" },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleNavigation(
                                                                folder
                                                              )
                                                            },
                                                            contextmenu:
                                                              function (
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.showContextMenu(
                                                                  $event,
                                                                  folder,
                                                                  "folder"
                                                                )
                                                              },
                                                          },
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "v-card-text",
                                                          {
                                                            staticClass:
                                                              "text-center pa-3",
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  size: "48",
                                                                  color:
                                                                    "primary",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-folder"
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-subtitle-2 mt-2 folder-name",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      folder.name
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              " " + _vm._s(folder.name) + " "
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                _vm._l(_vm.files, function (file) {
                                  return _c(
                                    "v-col",
                                    {
                                      key: file.id,
                                      staticClass: "pa-2",
                                      attrs: { cols: "auto" },
                                    },
                                    [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            top: "",
                                            "nudge-bottom": "20px",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on }) {
                                                  return [
                                                    _c(
                                                      "v-card",
                                                      _vm._g(
                                                        {
                                                          staticClass:
                                                            "file-card",
                                                          attrs: { hover: "" },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.getDocDetails(
                                                                file
                                                              )
                                                            },
                                                            contextmenu:
                                                              function (
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.showContextMenu(
                                                                  $event,
                                                                  file,
                                                                  "file"
                                                                )
                                                              },
                                                          },
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "v-card-text",
                                                          {
                                                            staticClass:
                                                              "text-center pa-3",
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  size: "48",
                                                                  color:
                                                                    _vm.getFileIconColor(
                                                                      file
                                                                    ),
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getFileIcon(
                                                                        file
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-subtitle-2 mt-2 file-name",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      file.name
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-caption text--secondary",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.formatTimestamp(
                                                                        file
                                                                          .audit
                                                                          .updated_on
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              " " + _vm._s(file.name) + " "
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                }),
                              ],
                              2
                            ),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { staticClass: "file-list" },
                          [
                            _c(
                              "v-list",
                              { staticClass: "pb-16", attrs: { dense: "" } },
                              [
                                _vm._l(_vm.filteredFolders, function (folder) {
                                  return _c(
                                    "v-list-item",
                                    {
                                      key: folder.id,
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleNavigation(folder)
                                        },
                                        contextmenu: function ($event) {
                                          $event.preventDefault()
                                          return _vm.showContextMenu(
                                            $event,
                                            folder,
                                            "folder"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-icon",
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "primary" } },
                                            [_vm._v("mdi-folder")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(_vm._s(folder.name)),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                _vm._l(_vm.files, function (file) {
                                  return _c(
                                    "v-list-item",
                                    {
                                      key: file.id,
                                      on: {
                                        click: function ($event) {
                                          return _vm.getDocDetails(file)
                                        },
                                        contextmenu: function ($event) {
                                          $event.preventDefault()
                                          return _vm.showContextMenu(
                                            $event,
                                            file,
                                            "file"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-icon",
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                color:
                                                  _vm.getFileIconColor(file),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.getFileIcon(file)
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(_vm._s(file.name)),
                                          ]),
                                          _c("v-list-item-subtitle", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatTimestamp(
                                                    file.audit.updated_on
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item-action",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.downloadFile(
                                                    file.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v("mdi-download"),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                  ],
              !_vm.loading && _vm.files.length === 0 && _vm.folders.length === 0
                ? _c(
                    "v-alert",
                    { staticClass: "ma-4", attrs: { type: "info", text: "" } },
                    [
                      _vm.searchedText.length === 0 && _vm.folders.length === 0
                        ? _c(
                            "div",
                            { staticClass: "text-center" },
                            [
                              _c(
                                "v-icon",
                                { attrs: { size: "48", color: "grey" } },
                                [_vm._v("mdi-folder-open")]
                              ),
                              _c("div", { staticClass: "text-h6 mt-2" }, [
                                _vm._v("This folder is empty"),
                              ]),
                              _vm.hasDocumentUploadAccess
                                ? _c(
                                    "div",
                                    { staticClass: "text-subtitle-1" },
                                    [_vm._v(" Drop files here to upload ")]
                                  )
                                : _vm._e(),
                              !_vm.hasDocumentUploadAccess
                                ? _c(
                                    "div",
                                    { staticClass: "text-subtitle-1" },
                                    [
                                      _vm._v(
                                        " No Folders or Files found in this directory. "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.searchedText.length > 0
                        ? _c(
                            "div",
                            { staticClass: "text-center" },
                            [
                              _c(
                                "v-icon",
                                { attrs: { size: "48", color: "grey" } },
                                [_vm._v("mdi-folder-open")]
                              ),
                              _c("div", { staticClass: "text-h6 mt-2" }, [
                                _vm._v("No Results"),
                              ]),
                              _c("div", { staticClass: "text-subtitle-1" }, [
                                _vm._v(
                                  " No files or folders match your search criteria. "
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              !_vm.loading && _vm.files.length > 0
                ? _c(
                    "v-toolbar",
                    { attrs: { flat: "", color: "toolbar" } },
                    [
                      _c(
                        "v-row",
                        { attrs: { justify: "end", align: "center" } },
                        [
                          _c(
                            "v-col",
                            {
                              staticStyle: { "max-width": "150px" },
                              attrs: { cols: "2", sm: "3" },
                            },
                            [
                              _c("v-select", {
                                staticClass: "mt-8",
                                attrs: {
                                  dense: "",
                                  items: _vm.pageSizes,
                                  label: "Items Per Page",
                                  "menu-props": {
                                    top: true,
                                    offsetY: true,
                                    maxHeight: 500,
                                  },
                                },
                                model: {
                                  value: _vm.pageSize,
                                  callback: function ($$v) {
                                    _vm.pageSize = $$v
                                  },
                                  expression: "pageSize",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mx-2",
                              attrs: {
                                icon: "",
                                large: "",
                                disabled: _vm.page === 1,
                              },
                              on: {
                                click: function ($event) {
                                  _vm.page--
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("mdi-chevron-left")])],
                            1
                          ),
                          _vm._v(" Page " + _vm._s(_vm.page) + " "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mx-2",
                              attrs: {
                                icon: "",
                                large: "",
                                disabled: _vm.files.length < _vm.pageSize,
                              },
                              on: {
                                click: function ($event) {
                                  _vm.page++
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("mdi-chevron-right")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "v-menu",
        {
          attrs: {
            "position-x": _vm.contextMenu.x,
            "position-y": _vm.contextMenu.y,
            absolute: "",
            "offset-y": "",
          },
          model: {
            value: _vm.contextMenu.show,
            callback: function ($$v) {
              _vm.$set(_vm.contextMenu, "show", $$v)
            },
            expression: "contextMenu.show",
          },
        },
        [
          _c(
            "v-list",
            { attrs: { dense: "" } },
            [
              _vm.contextMenu.type === "file"
                ? _c(
                    "v-list-item",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.downloadFile(_vm.contextMenu.item.id)
                        },
                      },
                    },
                    [
                      _c(
                        "v-list-item-icon",
                        [_c("v-icon", [_vm._v("mdi-download")])],
                        1
                      ),
                      _c("v-list-item-title", [_vm._v("Download")]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.contextMenu.type === "file" && _vm.isAdminUser
                ? _c(
                    "v-list-item",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.openDeleteDialog(_vm.contextMenu.item)
                        },
                      },
                    },
                    [
                      _c(
                        "v-list-item-icon",
                        [_c("v-icon", [_vm._v("mdi-delete")])],
                        1
                      ),
                      _c("v-list-item-title", [_vm._v("Delete")]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "800" },
          model: {
            value: _vm.previewDialog,
            callback: function ($$v) {
              _vm.previewDialog = $$v
            },
            expression: "previewDialog",
          },
        },
        [
          _vm.selectedFile
            ? _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    [
                      _vm._v(" " + _vm._s(_vm.selectedFile.name) + " "),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              _vm.previewDialog = false
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-card-text", [
                    _c(
                      "div",
                      { staticClass: "text-center" },
                      [
                        _c(
                          "v-icon",
                          {
                            attrs: {
                              size: "64",
                              color: _vm.getFileIconColor(_vm.selectedFile),
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.getFileIcon(_vm.selectedFile)) +
                                " "
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "text-h6 mt-2" }, [
                          _vm._v(_vm._s(_vm.selectedFile.name)),
                        ]),
                        _c("div", { staticClass: "text-body-2 mt-2" }, [
                          _vm._v(_vm._s(_vm.selectedFile.description)),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _vm.hasWriteAccess
                        ? _c(
                            "v-btn",
                            {
                              attrs: { color: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.editFile(_vm.selectedFile)
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-pencil"),
                              ]),
                              _vm._v(" Edit "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.hasWriteAccess
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "red white--text",
                              on: {
                                click: function ($event) {
                                  return _vm.openDeleteDialog(_vm.selectedFile)
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-delete"),
                              ]),
                              _vm._v(" Delete "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.downloadFile(_vm.selectedFile.id)
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-download"),
                          ]),
                          _vm._v(" Download "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.showDeleteDialog
        ? _c(
            "v-dialog",
            {
              attrs: { width: "450" },
              on: {
                "click:outside": function ($event) {
                  return _vm.closeDeleteDialog()
                },
              },
              model: {
                value: _vm.showDeleteDialog,
                callback: function ($$v) {
                  _vm.showDeleteDialog = $$v
                },
                expression: "showDeleteDialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [_vm._v("Delete Document")]),
                  _c("v-card-text", [
                    _vm._v(' Delete "' + _vm._s(_vm.selectedFile.name) + '"? '),
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "" },
                          on: {
                            click: function ($event) {
                              _vm.showDeleteDialog = false
                            },
                          },
                        },
                        [_vm._v("Close")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "red white--text",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.deleteFile(_vm.selectedFile)
                            },
                          },
                        },
                        [_vm._v("Delete")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }